<template>
	<div>
		<RadioGroup
			v-model="necessary"
			:options="[
				{ value: true, text: 'Ja' },
				{ value: false, text: 'Nein' },
			]"
			@change="emitChangeEvent"
		/>
		<div v-if="extraDataEligible" class="sections mt-4">
			<section>
				<h3>Wohin gehen die Reisen?</h3>
				<CharacteristicEdit
					v-model="geo"
					title="Wohin gehen die Reisen?"
					:characteristic-items="geoCharacteristicItems"
					:characteristic-type="meta.geoType"
					:nothing-allowed="{
						onlyOverall: true,
						overall: {
							text: 'Weltweit',
						}
					}"
					:selected-items-config="{
						showExperience: false,
					}"
					:group-by-letter="{
						enabled: false
					}"
					with-keyword
					open-fan-button-alignment="left"
					label-type="job-profile"
					@input="emitChangeEvent"
				/>
			</section>
			<section>
				<h3>Wie viele Tage pro Monat muss im Durchschnitt gereist werden?</h3>
				<CharacteristicSelectInline
					v-model="scope"
					:characteristic-items="meta.travelWillingness"
					initial-show-all
					single-choice
					label-type="job-profile"
					@input="emitChangeEvent"
				/>
			</section>
			<section>
				<h3>Gibt es externe Übernachtungen?</h3>
				<CharacteristicSelectInline
					v-model="externalSleepover"
					:characteristic-items="meta.externalSleepover"
					initial-show-all
					:nothing-allowed="{
						text: 'Es sind keine externen Übernachtungen nötig'
					}"
					single-choice
					label-type="job-profile"
					@input="emitChangeEvent"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import * as MaxDepth from "@/helper/characteristic/MaxDepth"
import _ from "lodash";
import RadioGroup from "@/vue/common/form/RadioGroup";
import {isDefined} from "@/helper/Value";
import CharacteristicEdit from "@/vue/characteristic/Edit";
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline";

export default {

	components: {
		RadioGroup,
		CharacteristicEdit,
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			necessary: this.value?.necessary,
			geo: this.value?.geo,
			scope: this.value?.scope,
			externalSleepover: this.value?.externalSleepover,
			geoCharacteristicItems: Object.freeze(
				MaxDepth.filter(_.cloneDeep(this.meta.geo), 0)
			),
		};
	},

	computed: {
		extraDataEligible ()
		{
			return this.necessary === true;
		},
		extraDataValid ()
		{
			if (!this.extraDataEligible)
			{
				return true;
			}

			return isDefined(this.geo) && isDefined(this.scope) && isDefined(this.externalSleepover);
		},
		dataValid ()
		{
			return isDefined(this.necessary)
				&& this.extraDataValid;
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				necessary: this.necessary,
				geo: this.extraDataEligible
					? this.geo
					: undefined,
				scope: this.extraDataEligible
					? this.scope
					: undefined,
				externalSleepover: this.extraDataEligible
					? this.externalSleepover
					: undefined,
			});
		}
	}
}
</script>
